import { format } from 'date-fns';
import { formatMoney } from '../../../../../utils/formatters';
export function buildTransactionsTableData(transactions, currencyCode) {
    var _a;
    var headers = ['Data', 'Quantidade da cota', 'Valor da cota', 'Quantia'];
    if (!transactions) {
        return { headers: headers, rowsData: [] };
    }
    var rowsData = [];
    for (var _i = 0, transactions_1 = transactions; _i < transactions_1.length; _i++) {
        var transaction = transactions_1[_i];
        var date = format(new Date(transaction.date), 'dd/MM/yyyy');
        var qunatity = (_a = transaction.quantity) !== null && _a !== void 0 ? _a : '-';
        var quotaValue = transaction.value !== null
            ? formatMoney(transaction.value, currencyCode)
            : '-';
        var netAmount = transaction.netAmount !== null
            ? formatMoney(transaction.netAmount, currencyCode)
            : '-';
        rowsData.push([date, qunatity, quotaValue, netAmount]);
    }
    return { headers: headers, rowsData: rowsData };
}
